import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import Loading from 'components/shared-components/Loading'

export const EnrollmentViews = ({ match }) => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Switch>
        <Route
          path={`${match.url}`}
          component={lazy(() => import(`./enrollment`))}
        />
      </Switch>
    </Suspense>
  )
}

EnrollmentViews.propTypes = {
  match: PropTypes.object.isRequired,
}

export default EnrollmentViews
